import React, { useRef, useState, useEffect } from "react"
import SimpleBar from "simplebar-react"
import withRouter from "components/Common/withRouter"
import { Link, useLocation } from "react-router-dom"
import { withTranslation } from "react-i18next"
import {
  FaCalendarAlt,
  FaChevronDown,
  FaChevronRight,
  FaHistory,
  FaHome,
  FaHotdog,
  FaSalesforce,
  FaUsers,
  FaChartPie,
} from "react-icons/fa"
import { MdStackedLineChart } from "react-icons/md"
import Configs from "../../config"
import PropTypes from "prop-types"
import { FaArrowsLeftRight } from "react-icons/fa6"
import { BsFilePdf, BsGraphUpArrow } from "react-icons/bs"

const SidebarContent = () => {
  const ref = useRef()
  const [openSubmenus, setOpenSubmenus] = useState({})
  const { pathname } = useLocation()

  const isActive = path => pathname === `${Configs.appurl}${path}`

  const menuItems = [
    {
      to: "dashboard",
      icon: <FaHome size={18} className="me-2" />,
      label: "Home",
    },
    {
      to: "dashboard-history",
      icon: <FaHistory size={14} className="me-2 mb-1" />,
      label: "History Chart",
    },
    {
      to: "sales-Revenue",
      icon: <FaSalesforce size={18} className="me-2 mb-1" />,
      label: "Sales Revenue",
    },
    {
      to: "suasage",
      icon: <FaHotdog size={18} className="me-2 mb-1" />,
      label: "Sausage Category",
    },
    {
      to: "gmp",
      icon: <FaCalendarAlt size={18} className="me-2 mb-1" />,
      label: "GMP",
    },
    {
      to: "oee",
      icon: <FaUsers size={18} className="me-2 mb-1" />,
      label: "OEE",
    },
    {
      to: "plcharts",
      icon: <MdStackedLineChart size={18} className="me-2 mb-1" />,
      label: "Profit & Loss",
    },
    {
      to: "net-margin",
      icon: <FaChartPie size={16} className="me-2 mb-1" />,
      label: "Customer Report",
    },
    {
      to: "sales-report",
      icon: <BsGraphUpArrow size={18} className="me-2" />,
      label: "Sales Report",
    },
    {
      to: "guage-range",
      icon: <FaArrowsLeftRight size={18} className="me-2" />,
      label: "Gauge Ranges",
    },

    {
      to: "logs",
      icon: <BsFilePdf size={18} className="me-2" />,
      label: "Sheet Logs",
    },
  ]

  // Auto-open submenu if a child route is currently active
  useEffect(() => {
    const initial = {}
    menuItems.forEach((item, index) => {
      if (item.children?.some(child => isActive(child.to))) {
        initial[index] = true
      }
    })
    setOpenSubmenus(initial)
  }, [pathname])

  const toggleSubmenu = index => {
    setOpenSubmenus(prev => ({ ...prev, [index]: !prev[index] }))
  }

  return (
    <React.Fragment>
      <SimpleBar ref={ref} style={{ height: "calc(100vh - 70px)" }}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {menuItems.map((item, index) => {
              const hasChildren = item.children?.length > 0
              const isOpen = openSubmenus[index]
              const active = isActive(item.to)

              return (
                <li
                  key={index}
                  className={`mx-2 ${
                    active ||
                    (hasChildren && item.children.some(c => isActive(c.to)))
                      ? "mm-active"
                      : ""
                  }`}
                >
                  {hasChildren ? (
                    <>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Link
                          to={`${Configs.appurl}${item.to}`}
                          className={active ? "active" : ""}
                          style={{ flex: 1 }}
                        >
                          {item.icon}
                          {item.label}
                        </Link>
                        <span
                          onClick={() => toggleSubmenu(index)}
                          style={{
                            cursor: "pointer",
                            padding: "4px 8px",
                            color: "#6c757d",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {isOpen ? (
                            <FaChevronDown size={10} />
                          ) : (
                            <FaChevronRight size={10} />
                          )}
                        </span>
                      </div>

                      {isOpen && (
                        <ul
                          className="list-unstyled"
                          style={{
                            paddingLeft: "28px",
                            paddingTop: "4px",
                            paddingBottom: "4px",
                            borderLeft: "2px solid #e9ecef",
                            marginLeft: "20px",
                            marginTop: "2px",
                          }}
                        >
                          {item.children.map((child, ci) => (
                            <li
                              key={ci}
                              className={isActive(child.to) ? "mm-active" : ""}
                            >
                              <Link
                                to={`${Configs.appurl}${child.to}`}
                                className={isActive(child.to) ? "active" : ""}
                                style={{ fontSize: "13px", padding: "6px 0" }}
                              >
                                {child.icon}
                                {child.label}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </>
                  ) : (
                    <Link
                      to={`${Configs.appurl}${item.to}`}
                      className={active ? "active" : ""}
                    >
                      {item.icon}
                      {item.label}
                    </Link>
                  )}
                </li>
              )
            })}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
